import { render } from "./SaleSetting.vue?vue&type=template&id=3a98d76e&scoped=true"
import script from "@/assets/js/sale.js?vue&type=script&lang=js&external"
export * from "@/assets/js/sale.js?vue&type=script&lang=js&external"

import "@/assets/css/sale.css?vue&type=style&index=0&id=3a98d76e&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a98d76e"]])

export default __exports__